// Fetches the support articles once (shared across components via the useAsyncData key)
// and returns them sorted by their `order` frontmatter field.
export async function useSupportArticles() {
  const localePath = useLocalePath()
  const supportRoot = localePath('/support')

  const { data } = await useAsyncData(`supportArticles-${supportRoot}`, () =>
    queryCollection('content')
      .where('path', 'LIKE', `${supportRoot}/%`)
      .select('path', 'title', 'description', 'icon', 'order')
      .all(),
  )

  const articles = computed(() =>
    [...(data.value ?? [])].sort(
      (first, second) =>
        (first.order ?? Number.MAX_SAFE_INTEGER) - (second.order ?? Number.MAX_SAFE_INTEGER),
    ),
  )

  return { supportRoot, articles }
}
